import React from "react"
import { Box, Image, Typography, Grid } from "src/UILibrary"
import { useMediaQuery } from "react-responsive"
import { Product } from "src/openapi"

interface Props {
  item: Product
}

export const JobOfferItem = ({ item }: Props) => {
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  return (
    <Grid
      container
      sx={{
        mt: "40px",
      }}
      onClick={() => window.open(item.linkUrl, "_blank")}
    >
      <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
        <Image
          src={item.imageUrl!}
          sx={{
            height: isTablet ? "180px" : "240px",
            bgcolor: "divider",
            flex: 1,
            mr: isTablet ? "10px" : "0px",
            ":hover": { opacity: 0.8, cursor: "pointer" },
            "& img": {
              objectFit: "contain",
              backgroundColor: "white",
              maxWidth: "100%",
              width: "100%",
              height: "100%",
            },
          }}
          imageStyle={{ width: "100%", height: "100%" }}
        />
      </Grid>
      <Grid item xl={8} lg={8} md={12} sm={12} xs={12} sx={{ m: "auto" }}>
        <Box
          sx={{
            mt: isTablet ? "0px" : "20px",
            mb: "10px",
            ":hover": { opacity: 0.8, cursor: "pointer" },
          }}
        >
          <Typography.Description
            className="weight500 restrict_line"
            color="textPrimary"
            fontSize="20px"
            lineHeight="20px"
          >
            {item.title}
          </Typography.Description>
        </Box>
        <Box sx={{ ":hover": { opacity: 0.8, cursor: "pointer" } }}>
          <Typography.SubTitle
            className="notosans weight500 restrict_line_3"
            color="textPrimary"
            fontSize="16px"
            lineHeight="24px"
          >
            {item.description}
          </Typography.SubTitle>
        </Box>
      </Grid>
    </Grid>
  )
}
